/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptsControllerUpdateMutationResponse, PromptsControllerUpdatePathParams, PromptsControllerUpdate400, PromptsControllerUpdate401, PromptsControllerUpdate403, PromptsControllerUpdate404 } from "../../models/promptsController/PromptsControllerUpdate";

function getPromptsControllerUpdateUrl(id: PromptsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/prompts/${id}` as const }  
  return res
}

/**
 * @summary Update a prompt
 * {@link /api/v1/prompts/:id}
 */
export async function promptsControllerUpdate(id: PromptsControllerUpdatePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PromptsControllerUpdateMutationResponse, ResponseErrorConfig<PromptsControllerUpdate400 | PromptsControllerUpdate401 | PromptsControllerUpdate403 | PromptsControllerUpdate404>, unknown>({ method : "PATCH", url : getPromptsControllerUpdateUrl(id).url.toString(), ... requestConfig })  
  return res.data
}